import React from 'react';
import GridContextProvider from '../../context/context';

const ConnexDataGridProvider = ({ children, ...props }) => {
  return <GridContextProvider {...props}>{children}</GridContextProvider>;
};

export default ConnexDataGridProvider;
